import { Directive, ElementRef, AfterViewInit, Input, Host } from '@angular/core';

import { MatInput } from '@angular/material/input';

@Directive({
  selector: '[autoFocus1]',
})
export class AutofocusDirective implements AfterViewInit {

  @Input() public autoFocus = true;

  constructor(
    @Host() private _matInput: MatInput,
    private _el: ElementRef,
  ) {}

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this._matInput.focus();
    }, 100);
  }

}
